<template>
  <Popup :header="''" @accept="acceptAndClose()" @abort="closePopup()">
    <template v-slot:content>
      {{ text }}
    </template>
    <template v-slot:accept-btn-label> Löschen </template>
  </Popup>
</template>

<script>
import Popup from '@/components/base_components/Popup';

export default {
  name: 'LoeschenPopup',
  components: { Popup },
  props: {
    text: {
      type: String,
      default: "Wirklich löschen?",
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    closePopup() {
      this.$emit('cancel');
    },
    acceptAndClose() {
      this.$emit('delete');
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
